<template>
  <v-alert
    v-if="visible"
    type="info"
    variant="tonal"
    density="compact"
    class="pwa-install-banner"
  >
    <div v-if="canPromptInstall || showIosTip" class="pwa-install-banner__content">
      <div class="pwa-install-banner__row">
        <div v-if="canPromptInstall" class="pwa-install-banner__text">
        Puedes instalar Escribonauta como aplicación para acceder más rápido. Si cierras este aviso, puedes descargarla en cualquier momento desde Mi Cuenta.
        </div>
        <div v-else class="pwa-install-banner__text">
        Instala Escribonauta: toca Compartir › Agregar a inicio
        </div>

        <v-btn
          icon="mdi-close"
          variant="text"
          size="x-small"
          aria-label="Cerrar"
          @click="dismiss"
        />
      </div>
      <div v-if="canPromptInstall" class="pwa-install-banner__actions">
        <v-btn
          color="info"
          variant="flat"
          size="x-small"
          :loading="isInstalling"
          @click="onInstall"
        >
          Instalar
        </v-btn>
      </div>
    </div>
  </v-alert>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

import { usePwaInstall } from '@/composables/usePwaInstall'

export default defineComponent({
  name: 'PwaInstallBanner',

  setup() {
    const { visible, canPromptInstall, showIosTip, promptInstall, dismiss } = usePwaInstall()
    const isInstalling = ref(false)

    async function onInstall() {
      isInstalling.value = true
      try {
        await promptInstall()
      } finally {
        isInstalling.value = false
      }
    }

    return {
      visible,
      canPromptInstall,
      showIosTip,
      dismiss,
      isInstalling,
      onInstall,
    }
  },
})
</script>

<style scoped>
.pwa-install-banner {
  position: sticky;
  top: 0;
  z-index: 0;
  border-radius: 0;
  background: rgb(var(--v-theme-surface)) !important;
}

.pwa-install-banner :deep(.v-alert__underlay) {
  opacity: 1;
  background: rgba(var(--v-theme-info), 0.16) !important;
}

.pwa-install-banner__content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pwa-install-banner__row {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}

.pwa-install-banner__text {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 0.8125rem;
  line-height: 1.3;
}

.pwa-install-banner__actions {
  display: flex;
  align-items: center;
}

.pwa-install-banner :deep(.v-alert__content) {
  padding-block: 2px;
}
</style>
